// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"678":"e6012212","969":"e80d1144"}[chunkId] + ".chunk.js");